
<template>
<!-- 答题卡分享 -->
  <div class="modal-share">
    <el-dialog
      title="分享"
      :visible.sync="dialogVisible"
      width="30%"
      @close="closeDialog"
      custom-class="dialog_share"
      >
      <p style="margin: 0 0 35px 12px;color: #999">
        分享答题卡ID导入后可跨账户编辑当前答题卡
      </p>
      <el-form ref="ruleForm">
        <el-form-item label="答题卡名称: " :label-width="formLabelWidth">
          <span v-html="acCardName"></span>
          <!-- <el-input v-model="formdata.acCardName" autocomplete="off" style="width: 300px !important"></el-input> -->
        </el-form-item>
        <el-form-item label="答题卡ID: " :label-width="formLabelWidth">
          <div style="display: flex">
          <el-input disabled v-model="shareCode" autocomplete="off" style="width: 300px !important">
            <el-button type="primary" slot="append" @click="handleCopy()" >复制</el-button>
            <!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
          </el-input>
          </div>
           </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel('cancel')" type="primary">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AcCardApi from "@/services/acCard"
export default {
  props:{
    value: {
      type: Boolean,
      default: false,
    },
    acCardName: {
      type: String,
      default: '未知'
    },
    shareCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formLabelWidth: '100px',
      dialogVisible: false,
      formdata: {
        shareCode: '', // 根据guid获取的分享码
        acCardGuid: '', // guid
      },
    }
  },
  methods: {
    /**
     * 复制分享码
     */
    handleCopy() {
      const temporaryInput = document.createElement('input');// 临时构建一个input实例
      temporaryInput.value = this.shareCode;
      document.body.append(temporaryInput);
      temporaryInput.select();
      document.execCommand("copy");
      this.$message({
        message: '复制成功',
        type: 'success'
      }); 
      document.body.removeChild(temporaryInput); // 销毁input实例
    },
    async handleSubmit(formName) {
      const result = await AcCardApi.ShareToCard({
        acCardGuid: this.formdata.acCardGuid,
      });
      if(result.status == 200) {
        this.$message({
          message: '操作成功~',
          type: 'success'
        });
      } else {
        // this.$message({
        //   message: result.message,
        //   type: 'error'
        // });
      }
      this.dialogVisible = false;
    },
    handleCancel(name) {
      this.dialogVisible = false;
    },
    closeDialog(){
        this.$emit('input', false);
        this.formdata.shareCode = '';
    },
  },
  watch: {
    value(newVal) {
      if(newVal) {
        this.dialogVisible = true;
      }
    },
  },
  mounted() {
  }
}
</script>

<style lang="scss" >
.modal-share{
.el-select .el-input{
  width: 300px !important;
}
.el-input-group__append{
  background-color: #66b1ff;
  color: #fff;
  border: 1px solid #66b1ff;
}
}
.dialog_share{
.el-form-item span{
  padding: 0;
}
}

</style>